import XLSX from 'xlsx-js-style';

/** Legacy spreadsheet formats intentionally supported by the shared writer. */
export type LegacySpreadsheetFormat = 'csv' | 'xls';

function legacyBookType(format: LegacySpreadsheetFormat): 'csv' | 'biff8' {
  switch (format) {
    case 'csv':
      return 'csv';
    case 'xls':
      return 'biff8';
    default: {
      const unreachable: never = format;
      throw new TypeError(`Unsupported legacy spreadsheet format: ${String(unreachable)}`);
    }
  }
}

function toArrayBuffer(output: unknown): ArrayBuffer {
  if (output instanceof ArrayBuffer) return output;
  if (ArrayBuffer.isView(output)) {
    return output.buffer.slice(
      output.byteOffset,
      output.byteOffset + output.byteLength,
    ) as ArrayBuffer;
  }
  throw new TypeError('xlsx-js-style did not return binary array output');
}

/**
 * Serialize a native xlsx-js-style workbook through the shared engine boundary.
 *
 * CSV follows SheetJS semantics and emits the workbook's first worksheet.
 * XLS emits the Excel 97-2004 BIFF8 container.
 */
export function serializeLegacySpreadsheet(
  workbook: XLSX.WorkBook,
  format: LegacySpreadsheetFormat,
): ArrayBuffer {
  return toArrayBuffer(XLSX.write(workbook, {
    type: 'array',
    bookType: legacyBookType(format),
  }));
}
